import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../styles/stylesInicio.css';

const Inicio = () => {
    const { hash } = useLocation();
    const carouselRef = useRef(null);
    const directionRef = useRef('right'); 
    const [noticiasDestacadas, setNoticiasDestacadas] = useState([]);
    const [loadingNoticias, setLoadingNoticias] = useState(true);

    // --- SCROLL Y FETCH IGUAL QUE ANTES ---
    useEffect(() => {
        if (hash) {
            const elem = document.querySelector(hash);
            if (elem) elem.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [hash]);

    useEffect(() => {
        const fetchNoticiasHome = async () => {
            try {
                setLoadingNoticias(true);
                const { data, error } = await supabase
                    .from('noticias')
                    .select('id, titulo, resumen, fecha, imagen_url')
                    .order('fecha', { ascending: false })
                    .limit(6);
                if (error) throw error;
                setNoticiasDestacadas(data || []);
            } catch (error) {
                console.error("Error cargando noticias:", error);
            } finally {
                setLoadingNoticias(false);
            }
        };
        fetchNoticiasHome();
    }, []);

    // --- LÓGICA DE CARRUSEL ---
    const getScrollAmount = () => {
        if (carouselRef.current && carouselRef.current.firstChild) {
            // Obtenemos el ancho de la tarjeta + el gap
            return carouselRef.current.firstChild.clientWidth; 
        }
        return 300;
    };

    const scroll = (direction) => {
        if(carouselRef.current) {
            const { current } = carouselRef;
            const amount = getScrollAmount();
            if (direction === 'left') {
                current.scrollBy({ left: -amount, behavior: 'smooth' });
            } else {
                current.scrollBy({ left: amount, behavior: 'smooth' });
            }
        }
    };

    // Auto-scroll
    useEffect(() => {
        const interval = setInterval(() => {
            if (carouselRef.current) {
                const { current } = carouselRef;
                const amount = getScrollAmount();
                const maxScrollLeft = current.scrollWidth - current.clientWidth;

                if (directionRef.current === 'right') {
                    if (current.scrollLeft >= maxScrollLeft - 10) {
                        directionRef.current = 'left';
                        current.scrollBy({ left: -amount, behavior: 'smooth' });
                    } else {
                        current.scrollBy({ left: amount, behavior: 'smooth' });
                    }
                } else {
                    if (current.scrollLeft <= 10) {
                        directionRef.current = 'right';
                        current.scrollBy({ left: amount, behavior: 'smooth' });
                    } else {
                        current.scrollBy({ left: -amount, behavior: 'smooth' });
                    }
                }
            }
        }, 5000); // 5 segundos para leer mejor
        return () => clearInterval(interval);
    }, [noticiasDestacadas]); 

    return (
        <div className="inicio-wrapper">
            
            {/* ... SECCIÓN 1 (HERO) SE MANTIENE IGUAL ... */}
            <section className="seccionInicio" id="seccion1Inicio">
                <div className="inicio-hero-container">
                    <div className="inicio-image-wrap">
                        <img
                            src="https://bbbqjdnfrlibwibbyjmb.supabase.co/storage/v1/object/public/resources/portadaDeArriba-convertido-de-jpg.webp"
                            className="inicio-image-bg"
                            alt="Progreso"
                        />
                        <div className="inicio-overlay-dark"></div>
                    </div>
                    <div className="inicio-hero-content centered">
                        <h1 className="progreso-big-title">PROGRESO</h1>
                        <p className="progreso-subtitle">sigamos creciendo juntos</p>
                    </div>
                </div>
            </section>

            {/* --- SECCIÓN 2: ÚLTIMAS NOTICIAS (MODIFICADA) --- */}
            <section className="seccion-noticias-destacadas">
                
                <div className="noticias-content-wrapper">
                    <div className="noticias-header">
                        <h2>Últimas Novedades</h2>
                        <p>Mantente informado sobre lo que pasa en nuestro pueblo</p>
                    </div>
                    
                    <div className="carousel-wrapper">
                        {/* Botón Izquierdo */}
                        <button className="carousel-btn left" onClick={() => scroll('left')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                        </button>
                        
                        <div className="noticias-carousel" ref={carouselRef}>
                            {loadingNoticias && <p className="loading-text">Cargando novedades...</p>}
                            
                            {!loadingNoticias && noticiasDestacadas.map((noticia) => (
                                <Link to="/Noticias" key={noticia.id} className="noticia-card-large">
                                    <div className="noticia-img-wrap">
                                        <img src={noticia.imagen_url || '/resources/comuna.jpg'} alt={noticia.titulo} onError={(e) => {e.target.src = '/resources/comuna.jpg'}} />
                                    </div>
                                    <div className="noticia-info">
                                        <h3>{noticia.titulo}</h3>
                                        <p>{noticia.resumen ? noticia.resumen.substring(0, 80) + '...' : ''}</p>
                                        <span className="leer-mas">LEER MÁS →</span>
                                    </div>
                                </Link>
                            ))}
                            
                            {!loadingNoticias && noticiasDestacadas.length === 0 && <p className="loading-text">No hay noticias recientes.</p>}
                        </div>
                        
                        {/* Botón Derecho */}
                        <button className="carousel-btn right" onClick={() => scroll('right')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                        </button>
                    </div>

                    <div className="ver-todas-container">
                        <Link to="/Noticias" className="btn-ver-todas" onClick={() => window.scrollTo(0, 0)}>VER MÁS NOTICIAS</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Inicio;